// @flow
import * as React from 'react';
import {
    Box, Button, Layer, Text,
} from 'grommet';
import styled from 'styled-components';

type Props = {
    message: React.Node,
    width?: Object | string,
    pad?: Object | string,
    actions?: { label: string, callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => void }[],
}

const StyledButton = styled(Button)`
    color: #fff;
`;

const WarningDialog = (props: Props) => {
    const {
        message, width, pad, actions,
    } = props;

    return (
        <Layer position="top" margin="small" modal={false} plain>
            <Box
                background="status-warning"
                pad={pad}
                round
                width={width}
                align="center"
            >
                <Text color="white">
                    {message}
                </Text>
                {actions
                && actions.map((action) => (
                    <StyledButton
                        key={action.label}
                        label={action.label}
                        onClick={action.callback}
                        color="#fff"
                    />
                ))}
            </Box>
        </Layer>
    );
};

WarningDialog.defaultProps = {
    width: { min: '800px' },
    pad: { vertical: 'xsmall', horizontal: 'small' },
    actions: [],
};

export default WarningDialog;
